import React, { FC } from 'react';
import './FromResetPassword.scss';
import { Form, Formik } from 'formik';
import { formResetSchema } from '../../../../helpers/validation';
import AppFormInput from '../../../../components/ui/forms/controls/AppFormInput';
import AppButton from '../../../../components/ui/components/Buttons/AppButton/AppButton';
import AppFormCode from '../../../../components/ui/forms/controls/AppFormCode';
import { FormikHelpers } from 'formik/dist/types';
import { useTranslation } from "react-i18next";
import { phoneMask } from "../../../../config";

interface InitialProps {
   password: string;
   login: string;
   password_confirmation: string;
}

interface Props {
   initialValues: InitialProps;
   onSubmit: (values: InitialProps, formikHelpers: FormikHelpers<InitialProps>) => any;
   isSending: boolean;
}

const FromResetPassword: FC<Props> = props => {
   const { initialValues, onSubmit, isSending } = props;
   const [t] = useTranslation();

   return (
      <Formik initialValues={initialValues} validationSchema={formResetSchema} onSubmit={onSubmit}>
         <Form>
            <div>
               <AppFormInput
                  type="text"
                  name="login"
                  label={'Номер вашого телефону'}
                  disabled
                  alwaysShowMask={true}
                  mask={phoneMask}
               />
               <AppFormCode name="code" label={t("Введіть код, який ми надіслали через SMS")} />
               <AppFormInput type="password" name="password" label={t("Пароль")} />
               <AppFormInput type="password" name="password_confirmation" label={t("Пароль")} />
            </div>

            <AppButton theme="primary" size="middle" className="sign-up__submit" showIndicator={isSending}>
               {t("Підтвердити")}
            </AppButton>
         </Form>
      </Formik>
   );
};

export default FromResetPassword;
